import {DictionaryOption} from '@dms/api/shared';

export const getDefaultDictionaryOptionValue = (options?: DictionaryOption[]) =>
  options?.find((option) => option.isDefault)?.value;
